import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'action-button',
  templateUrl: './action-button.component.html',
  styleUrls: ['./action-button.component.scss'],
})
export class ActionButtonComponent implements OnInit {
  _isBusy: boolean = false;
  private initialBusy: boolean = true;
 
  @Input() label: string = 'Save';
  @Input() busyLabel: string = 'Working... ';
  @Input() icon: string = 'save';
  @Input() enabled: boolean = true;
  @Input() forceDisabled: boolean = false;
  @Input() btnClasses: string = 'btn-primary';  

  @Output() onClicked = new EventEmitter<boolean>();

  @Input() set isBusy(busy: boolean) {
    this._isBusy = busy;

    if (!busy && !this.enabled && !this.initialBusy) this.enabled = true;
    this.initialBusy = false;
  }

  constructor() { }

  ngOnInit() {
  }

  onClick() {
    this.enabled = false;
    this.isBusy = true;
    this.onClicked.emit(true);
  }
}
